export interface DeleteSystemTopMenuRequest {
  id: string
  revision: number
}

export function DeleteSystemTopMenuRequestToJSON(
  value: DeleteSystemTopMenuRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
